import { useEffect, useRef } from 'react';

const DEFAULT_COLORS = ['#F04E1A', '#F5C842', '#3B6FBF', '#5A9E7A', '#9B59B6', '#E74C3C'];
const DURATION = 3200;

export default function Confetti({ onDone, colors }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const palette = colors?.length ? colors : DEFAULT_COLORS;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const W = canvas.width = window.innerWidth;
    const H = canvas.height = window.innerHeight;

    const particles = Array.from({ length: 150 }).map(() => ({
      x: Math.random() * W,
      y: -20 - Math.random() * H * 0.4,
      w: 6 + Math.random() * 6,
      h: 8 + Math.random() * 10,
      color: palette[Math.floor(Math.random() * palette.length)],
      vx: (Math.random() - 0.5) * 3,
      vy: 2 + Math.random() * 3,
      rot: Math.random() * 360,
      vrot: (Math.random() - 0.5) * 12,
    }));

    let raf, start = null;
    const tick = (t) => {
      if (!start) start = t;
      const elapsed = t - start;
      ctx.clearRect(0, 0, W, H);
      particles.forEach(p => {
        p.x += p.vx; p.y += p.vy; p.vy += 0.05; p.rot += p.vrot;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (elapsed < DURATION) raf = requestAnimationFrame(tick);
      else onDone?.();
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone, colors]);

  return <canvas ref={canvasRef} style={{ position:'fixed', inset:0, zIndex:3100, pointerEvents:'none' }}/>;
}
